import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Detail from '../views/Detail.vue'
import dynamiList from '../views/dynamiList.vue'
import messageList from '../views/messageList.vue'
import serveList from '../views/serveList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { code: 'HOME', title: '网站首页' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { code: 'GYWM', title: '关于我们' }
  },
  {
    path: '/serveList',
    name: 'ServeList',
    component: serveList,
    meta: { code: 'ZCFW', title: '仲裁服务' }
  },
  {
    path: '/dynamiList',
    name: 'DynamiList',
    component: dynamiList,
    meta: { code: 'SZDT', title: '双仲动态' }
  },
  {
    path: '/messageList',
    name: 'MessageList',
    component: messageList,
    meta: { code: 'TZGG', title: '通知公告' }
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router